import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';

import type { ModuleStatesDeclaration } from 'types/StateDeclaration';
import { AnimateEventModule } from '../ui/animate-event/animate-event.module';
import { DomainInputModule } from '../ui/domain-input/domain-input.module';
import { SharedModule } from '@app/shared/shared.module';

import { LoginComponent } from './login.component';

const routes: ModuleStatesDeclaration = {
  states: [
    {
      name: 'login',
      url: '/login',
      component: LoginComponent,
      data: {
        bodyClass: ['app-footer', 'app-white']
      }
    }
  ]
};

/**
 * Login (only company selection, as actual login is done in the BE)
 * mobile login is handled by another component
 */
@NgModule({
  imports: [AnimateEventModule, DomainInputModule, ReactiveFormsModule, SharedModule, UIRouterModule.forChild(routes)],
  declarations: [LoginComponent]
})
export class LoginModule {}
